import { ReactElement } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

type TGoToLinkProps = {
  title: string;
  icon?: ReactElement;
  extra?: ReactElement;
  onClick?: Function;
};

export const GoToLink = ({
  title,
  icon,
  extra,
  onClick
}: TGoToLinkProps): ReactElement => {
  return (
    <div className="goToLinkWrapper" onClick={() => onClick?.()}>
      {icon && <div className="icon-container">{icon}</div>}
      <div className="goToLinkTitle">{title}</div>
      {extra && <div className="extra-container">{extra}</div>}
    </div>
  );
};
